// extracted by mini-css-extract-plugin
export var claimsContainer = "claims-container__HlL5";
export var claimsSkeleton = "claims-skeleton__hUYM";
export var count = "count__jBOJ";
export var countContainer = "countContainer__Ye82";
export var header = "header__t6hP";
export var passportContainer = "passport-container__rx2u";
export var passportSkeleton = "passport-skeleton__OUoo";
export var recsContainer = "recs-container__vNLK";
export var recsSkeleton = "recs-skeleton__gji9";